import React,{useState,useEffect} from 'react'
import FooterSection from '../footer/page'
import Sidenav from '../Navbar/sideNav/page'
import HeaderSection from "../Navbar/page"
import { Link, useNavigate } from 'react-router-dom'
import Api from '../Api/Api'
import { RingLoader } from 'react-spinners'

function Page() {
    const [leaderProfileData,setleaderProfileData]=useState([]);
    const [loading, setLoading] = useState(false);
    const [openDropdown, setOpenDropDown] = useState(false);
    const [dropdownIndex, setDropDownIndex] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5; 
    const navigate = useNavigate();

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = leaderProfileData.slice(indexOfFirstItem, indexOfLastItem);

    // Calculate total pages
    const totalPages = Math.ceil(leaderProfileData.length / itemsPerPage);

// console.log("dropdownIndx", dropdownIndex)

    const handleDropDown =(index) =>{
      console.log("clicked", index)
        if (dropdownIndex === index) {
          setOpenDropDown(false); // Close the dropdown if it's already open
          setDropDownIndex(null); // Clear the dropdownIndex if it's being closed
        } else {
          setOpenDropDown(true);
          setDropDownIndex(index); // Open the dropdown for the clicked item
        }

    }


    const leaderFatchData=async()=>{
      setLoading(true)
      try {
        const userIdData = localStorage.getItem("UserIdMongo");
        // console.log("idiiiidididid", userIdData);
        const res = await Api.get(
          `/user/all-levels`
        );
        // console.log("res----->leaderfaafafafa", res.data.result);
        setleaderProfileData(res.data.result);
      } catch (error) {
        console.log(error)
      }
        setLoading(false)
    }



    useEffect(() => {
        leaderFatchData()
    }, [])



  return (
    <>
      {/* <div className="layout has-sidebar fixed-sidebar fixed-header">
        <Sidenav />

        <div className="layout">
          <main className="content">
            <HeaderSection /> */}

      {/* <section className="banner-section inner-banner position-relative about">
        <div className="shape-area">
            <img src="/assets/images/abs-items/bubble.png" className="shape-1" alt="icon" />
            <img src="/assets/images/abs-items/ellipse-7.png" className="shape-2" alt="icon" />
        </div>
        <div className="container position-relative">
            <div className="banner-content row justify-content-between">
                <div className="col-lg-6 col-md-10">
                    <div className="main-content">
                        <h2 className="visible-slowly-bottom display-four mb-6">Leaderboard</h2>
                        
                    </div>
                </div>
                <div className="col-lg-6 col-md-10 d-grid align-items-end justify-content-end">
                    <div className="breadcrumb-area position-absolute end-0 bottom-0">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb m-0 py-3 px-8 fs-six d-flex align-items-end justify-content-end">
                                <li className="breadcrumb-item p-0 m-0"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Leaderboard</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
 
    <section className="call-to-action  bettor-ranking overflow-hidden">
        <div className="container">
            <div className="row justify-content-between align-items-center">
               
                <div className="col-lg-8 offset-2">
                    
                      <div className="leaderboard">
                        <h2 className="text-center">Team Leaderboard</h2>
                        <div className="leaderboard-box-1 mt-5 mb-3">
                            <h5>S.No</h5>
                            <h5>Profile</h5>
                            <h5>Points</h5>
                            <h5>Timing</h5>
                            <h5>Level</h5>
                        </div>
                        {/* <div className="leaderboard-box">
                            <p className="text-center">1</p>
                            <div className="profil-lead pd-more pd-more">
                                <img src="/assets/images/team-members-1.png" />
                                <h5>Sophia Smith</h5>
                            </div> 
                           
                            <p className="text-center">2555</p>
                        </div> 

                      {leaderProfileData.length > 0 ? (
                        leaderProfileData?.map((item,index)=>(
                            
                      
                        <div className="leaderboard-box" key={index} style={{marginBottom:'7px'}}>
                            
                            <div>
                            <p className="text-center" style={{marginBottom:'0rem'}}>{index+1}</p>
                            </div>
                            <div className="profil-lead">
                                {/* <img src="/assets/images/team-members-1.png" />
                                <Link className='profile-icon'style={{width:"20px",height:'20px'}} >
                                    <i className="fa-regular fa-user"></i>
                                    </a>
                                {/* <h5>{item.userName}</h5> 
                                <h5>{item.userId.userName}</h5>
                            </div> 
                           
                            <p className="text-center" style={{marginBottom:'0rem'}}>{item.score}</p>
                            <p className="text-center" style={{marginBottom:'0rem'}}>{Math.floor((item.timeTaken / 60000) % 60)}m:{(item.timeTaken / 1000) % 60}s</p>
                            <p className="text-center" style={{marginBottom:'0rem'}}>{item.gameLevel}</p>


                            </div>
                        
                          ))
                          
                        ) : (
                            <p className="text-center">No data found</p>
                        )
                        }
                        
                      </div>
                </div>
            </div>
       
            <div className="pok-pagination" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-easing="ease-in">
                    <ul>
                        <li>
                            <a onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}><i className="fa-solid fa-angles-left"></i></a>
                        </li>
                        <li>
                            <a onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>01</a>
                        </li>
                        <li>
                            <a onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} className="active">02</a>
                        </li>
                        <li>
                            <a to="#0">03</a>
                        </li>
                        <li className="dotted">
                            <i className="fa-solid fa-ellipsis"></i>
                        </li>
                        <li>
                            <a onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>15</a>
                        </li>
                        <li>
                            <a onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>16</a>
                        </li>
                        <li>
                            <a onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}><i className="fa-solid fa-angles-right"></i></a>
                        </li>
                    </ul>
                </div>



	   </div>
    </section> */}

      {loading ? (
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "30%", marginBottom: "20%" }}
        >
          {/* <Loader/> */}
          <RingLoader color="rgb(50 92 213)" size="100" />
        </div>
      ) : (
        <>
        {/* <HeaderSection/> */}
          <section className="banner-section inner-banner position-relative about">
            <div className="shape-area">
              <img
                src="/assets/images/abs-items/bubble.png"
                className="shape-1"
                alt="icon"
              />
              <img
                src="/assets/images/abs-items/ellipse-7.png"
                className="shape-2"
                alt="icon"
              />
            </div>
            <div className="container position-relative">
              <div style={{ marginTop: "9%", cursor: "pointer" }}>
                <i class="fa fa-arrow-left" onClick={() => navigate("/")}></i>
              </div>
              <div className="banner-content row justify-content-between">
                <div className="col-lg-6 col-md-10">
                  <div className="main-content">
                    <h2 className="visible-slowly-bottom display-four mb-6">
                      Leaderboard
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 col-md-10 d-grid align-items-end justify-content-end">
                  <div className="breadcrumb-area position-absolute end-0 bottom-0">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb m-0 py-3 px-8 fs-six d-flex align-items-end justify-content-end">
                        <li className="breadcrumb-item p-0 m-0">
                          <a onClick={() => navigate("/")}>Home</a>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Leaderboard
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="faqs-section bettor-ranking overflow-hidden">
            <div className="pt-80 pb-80">
              <div className="container position-relative cus-z1">
                <div className="row d-flex justify-content-between">
                  <div className="col-lg-8 offset-2">
                    <h2 className="text-center mb-5">Levels</h2>
                    <div className="accordion" id="accordionFaqs">
                      {loading ? (
                        <div className="d-flex justify-content-center">
                          {/* <Loader/> */}
                          <RingLoader color="rgb(50 92 213)" size="100" />
                        </div>
                      ) : leaderProfileData.length === 0 ? (
                        <>
                          <div className="accordion-item">
                            <h5 className="accordion-header" id="headingOne">
                              <button
                                // className="accordion-button collapsed"
                                type="button"
                                // data-bs-toggle="collapse"
                                // data-bs-target="#collapseOne"
                                // aria-expanded="false"
                                // aria-controls="collapseOne"
                                style={{marginLeft:"34%"}}
                              >
                                <img src="/assets/images/icon/step.png" /> No
                                game played yet!
                              </button>
                            </h5>
                          </div>
                        </>
                      ) : (
                        leaderProfileData.map((item, index) => (
                          <div className="accordion-item">
                            <h5 className="accordion-header" id="headingOne">
                              <button
                                className="accordion-button angle-right"
                                type="button"
                                // data-bs-toggle="collapse"
                                // data-bs-target="#collapseOne"
                                // aria-expanded="false"
                                // aria-controls="collapseOne"
                                // onClick={() => handleDropDown(index)}
                                onClick={() =>
                                  navigate("games", {
                                    state: { level: item },
                                  })
                                }
                              >
                                <img src="/assets/images/icon/step.png" /> Level{" "}
                                {item}
                              </button>
                            </h5>
                            {/* {openDropdown && index == dropdownIndex ? (
                                <div
                                // id="collapseOne"
                                className="accordion-collapse "
                                // aria-labelledby="headingOne"
                                // data-bs-parent="#accordionFaqs"
                              >
                                <div className="accordion-body">
                                  {item.game.map((game, indx) => (
                                    <div className="d-flex justify-content-between align-items-center">
                                      <h5>Game {indx + 1}</h5>
                                      <Link
                                        to={`/Leaderscore/${game}`}
                                        className="flip1 box-stylee btn-box d-center"
                                      >
                                        View leaderboard
                                      </Link>
                                    </div>
                                  ))}
                                </div>
                              </div>
                              ): ""} */}
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <FooterSection />
        </>
      )}
      {/* </main>
        </div>
      </div> */}
    </>
  );
}

export default Page